import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { CommonChartProps } from "../../../../types/General";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const CommonChart: React.FC<CommonChartProps> = ({ title, colClass, options, series, chartHeight }) => {
  return (
    <Col className={colClass}>
      <Card>
        <CommonCardHeader title={title} />
        <CardBody>
          <div className="chart-container">
            <div>
              <ReactApexChart options={options} series={series} type={options.chart?.type} height={chartHeight} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CommonChart;
